import React from 'react'
import {useSelector} from 'react-redux';
import {RootState} from '../../../store';
import {Link} from 'react-router-dom'; // Added missing import for Link

const Account = () => {
  // Check authentication status from Redux store
  const isAuthenticated = useSelector((state: RootState) => state.auth.isAuthenticated);

  return (
      <div className={`${isAuthenticated ? '' : 'hidden'} flex flex-col text-sm font-semibold text-gray-500 dark:text-neutral-300 gap-2 mb-4 lg:mb-0`}>
        <div className="text-lg text-dark-primary mb-3">Account</div>
        <Link to="/profile">Profile</Link>
        <Link to="/profile/trades">Trades</Link>
        <div
            onClick={() => {
              if ((window as any).openCrispChat) {
                (window as any).openCrispChat();
              }
            }}
            className="cursor-pointer"
        >
          Support
        </div>
      </div>
  );
};

export default Account;